import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserSessionService } from '../services/user-session.service';

@Injectable()
export class AcceptLanguageInterceptor implements HttpInterceptor {

	constructor(
		private userSessionService: UserSessionService
	) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Get the current language from UserSessionService
        const language = this.userSessionService.getLanguage();

        // Clone the request and add the Accept-Language header
        const authReq = request.clone({
            setHeaders: {
                'Accept-Language': language
            }
        });

        return next.handle(authReq);
    }
}
